export default __webpack_public_path__ + "static/media/queen_of_swords.bea119e4.png";